module SiteStructuur

open ViewTypes
open Feliz


let renderContentLogic (state: State) (dispatch: Msg -> unit) =
    let songContent (state: SongState) dispatch =
        SongPage.render state (SongMsg >> dispatch)

    let lijstContent (state: LijstState) dispatch =
        ListPage.render state (ListMsg >> dispatch)

    let AgendaContent (state: State) dispatch =
        AgendaPage.render state (dispatch)

    //match state.ViewStatus with
    //| ViewStatus.ShowAgenda -> AgendaContent state dispatch
    //| _ ->
    //    if state.Song.SelectedSong.IsSome then
    //        songContent state.Song dispatch
    //    else
    //        lijstContent state.Lijst dispatch    match state.ViewStatus with
    match state.ViewStatus with
    | ViewStatus.ShowAgenda -> AgendaContent state dispatch
    | ViewStatus.ShowLijst -> lijstContent state.Lijst dispatch
    | ViewStatus.ShowSong -> songContent state.Song dispatch
    | _ ->lijstContent state.Lijst dispatch
        //if state.Song.SelectedSong.IsSome then
        //    songContent state.Song dispatch
        //else
        //    lijstContent state.Lijst dispatch



let private sideandcontent (state: State) (dispatch: Msg -> unit) =
    let sidebartoggle =
        if state.ShowSideBar then
            ""
        else
            " is-hidden"

    Html.div [
        prop.className "main container"
        prop.children [
            Html.div [
                prop.className "columns"
                prop.children [
                    Html.div [
                        prop.className ("column is-one-fifth" + sidebartoggle)
                        prop.children [
                            SideBar.render state dispatch
                        ]
                    ] // Hier de sidebar
                    Html.div [
                        prop.className "column"
                        prop.children [
                            Html.div [
                                prop.className "content"
                                prop.children [
                                    renderContentLogic state dispatch
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ]
    ] // hier de hoofdpagina

let private onlyContent (state:State) (dispatch: Msg-> unit) =
    Html.div [
        prop.className "column"
        prop.children [
            Html.div [
                prop.className "content"
                prop.children [
                    renderContentLogic state dispatch
                ]
            ]
        ]
    ]


let renderSite (state: State) (dispatch: Msg -> unit) =
    let hide = (state.Song.Fullscreen && state.Song.SelectedSong.IsSome)

    Html.div [
        if not hide then Header.header state dispatch
        if hide then onlyContent state dispatch
        else sideandcontent state dispatch
    ]
